/**
 * @file Email send page: composes and sends entity-related emails, including
 * the charge-summary table. The owner-statement period row is shown only for a
 * charge that is not on a direct payment route (`isDirectPaymentRoute`,
 * negated — direct-route charges never appear on an owner statement's period).
 *
 * Flow: email route → reads the addressed entity and its charges → dispatches
 * the email send action.
 * Exceptions: saga `onError` resets the sending flag; generic snackbar path.
 */
import * as React from 'react';
import { connect } from 'react-redux';
import Component from '../../AbstractComponent';
import Constants from '../../../Action/Constants';
import { isDirectPaymentRoute } from '../../../Entity/Entities/Charge/PaymentRoute';
import { getPaymentBaseAccountDisplay } from '../../../Entity/Entities/Payment/BaseBankAccount';
import { Property } from '../../../Entity/Entities/Property/Property';
import { Unit } from '../../../Entity/Entities/Unit/Unit';
import { Contract } from '../../../Entity/Entities/Contract/Contract';
import { Company } from '../../../Entity/Entities/Company/Company';
import { Person } from '../../../Entity/Entities/Person/Person';
// import { Charge } from "../../../Entity/Entities/Charge/Charge";
// import { Payment } from "../../../Entity/Entities/Payment/Payment";
import { Event } from '../../../Entity/Entities/Event/Event';
import { PromptDialog } from '../../Partials/Dialog/PromptDialog';
import { PageTransition } from '../../Partials/Spinner/PageTransition';
import { MiddlewareInterface } from '../../../Middleware/MiddlewareInterface';
import EmailSendWillMount from '../../../Middleware/Middlewares/EmailSendWillMount';
import PreventPageLeave from '../../../Middleware/Middlewares/PreventPageLeave';
import Card from '@material-ui/core/Card';
import TextField from '../../Partials/Material/TextField';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import CreatableSelect from 'react-select/creatable';
import { Attachment } from '../../Partials/Attachment/Attachment';
import Environment from '../../../Environment/Environment';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { ChargeInterface } from '../../../Entity/Entities/Charge/ChargeInterface';
import { PaymentInterface } from '../../../Entity/Entities/Payment/PaymentInterface';
import { ContractInterface } from '../../../Entity/Entities/Contract/ContractInterface';
import Time from '../../../Time/Time';

class EmailSend extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_EMAIL_SEND_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    EmailSendWillMount,
    PreventPageLeave,
  ];

  public state = {
    emailTo: '',
    emailsCC: [],
    message: '',
    attachments: [],
    attachmentIds: [],
    selectedAttachmentsIds: [],
    hasModifiedData: false,
    isSaving: false,
    nextPath: '',
    openLeavePrompt: false,
    selectedEntityForEmail: null,
    entityName: '',
    languageForPdf: this.props.app?.settings?.agency?.defaultLocale?.iso,
    showEmailField: true,
    showMessageField: true,
    firstInvoice: null,
    useAgencyNameForEmail: false,
    emailToPersonName: '',
    messageBeginning: '',
    footerText: '',
    sendReminder: false,
    sendCopyToEmails: [],
    sendCopyToSubject: '',
    sendCopyTo: false,
    autoFocusEmailTo: false,
    autoFocusMessage: false,
    messageManuallyChanged: false,
    isNotValidTo: false,
    agencyFee: null,
  };

  constructor(public props) {
    super(props);
  }

  public componentWillUnmount() {
    this.props.dispatch({
      type: Constants.GLOBAL_EMAIL_SEND_CLEAR,
    });

    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public initializePage = (entity?) => {
    const settings = this.props?.app?.settings?.agency;
    let state: any = {
      selectedAttachmentsIds: this.state.selectedAttachmentsIds.length
        ? this.state.selectedAttachmentsIds
        : this.state.attachments
            ?.filter((attachment) => attachment?.automaticallyCreated)
            ?.map((attachment) => attachment.id),
      selectedEntityForEmail: entity,
      showEmailField: false,
      showMessageField: false,
      sendReminder:
        this.props?.location?.query?.reminder === 'true' ? true : null,
      firstInvoice:
        this.props?.location?.query?.firstInvoice === 'true' ? 'first' : 'last',
      languageForPdf: settings?.defaultLanguage?.iso,
      useAgencyNameForEmail: settings?.useAgencyNameForEmail,
      sendCopyToEmails: this.props.app?.settings?.agency?.sendCopyToEmails,
      sendCopyToSubject: this.props.app?.settings?.agency?.sendCopyToSubject,
      sendCopyTo: !!(
        this.props.app?.settings?.agency?.sendCopyToSubject?.length &&
        this.props.app?.settings?.agency?.sendCopyToSubject
      ),
      agencyFee:
        this.state.entityName === 'renewed-contract'
          ? this.props.app?.agencyFees.find(
              (fee) => fee?.objectId === entity?.unitId && !fee?.lastDate
            )
          : null,
    };
    let emailToPerson;
    console.log(entity?.unit?.property?.company?.generalContactId, 'entity');
    console.log(
      'GSX',
      this.props.app?.companies.find(
        (company) => company.id === entity?.unit?.property?.company?.id
      )?.generalContact
    );
    switch (this.state.entityName) {
      case 'statement':
        emailToPerson = this.props.app?.companies.find(
          (company) => company.id === entity?.ownerId
        )?.generalContact;
        break;
      case 'charge':
        emailToPerson = entity?.contact || entity?.company?.generalContact;
        break;
      case 'payment':
        emailToPerson = entity?.person || entity?.company?.generalContact;
        break;
      case 'task':
        emailToPerson = entity?.executor;
        break;
      case 'contract':
        emailToPerson = entity?.person;
        break;
      case 'renewed-contract':
        emailToPerson = this.props.app?.companies.find(
          (company) => company.id === entity?.unit?.property?.company?.id
        )?.generalContact;
        state.languageForPdf = this.props.app?.companies.find(
          (company) => company.id === entity?.unit?.property?.company?.id
        )?.generalContact?.languageTypeId;
        state.emailTo = this.props.app?.companies.find(
          (company) => company.id === entity?.unit?.property?.company?.id
        )?.generalContact?.email;
        break;
      case 'new-contract':
        emailToPerson = entity?.person;
        state.languageForPdf = entity?.tenant?.languageTypeId;
        break;
      case 'tenant-login-portal-link':
        emailToPerson = entity;
        break;
    }
    console.log(emailToPerson, 'emailToPerson');
    if (emailToPerson?.firstName) {
      state.emailToPersonName = emailToPerson?.firstName?.trim();
    }

    if (emailToPerson?.email) {
      state.emailTo = emailToPerson?.email;
    }

    // TODO fix hardcoded values
    if (emailToPerson?.languageTypeId === 1) {
      state.languageForPdf = 'en-US';
    } else if (emailToPerson?.languageTypeId === 2) {
      state.languageForPdf = 'nl-NL';
    }

    if (state.emailTo) {
      state.autoFocusMessage = true;
    } else {
      state.autoFocusEmailTo = true;
    }

    this.setState(
      {
        ...state,
        ...this.props.app?.savedDataBeforeRedirecting?.[
          `emailSendDataToBeSaved`
        ],
      },
      () => {
        // hack to rerender react-select because probably
        // it has bug when first default value was undefined and then received some value
        // CASA-8243
        this.setState({
          showEmailField: true,
          showMessageField: true,
        });

        if (
          this.props.app?.savedDataBeforeRedirecting?.[
            `emailSendDataToBeSaved`
          ] &&
          Object.keys(
            this.props.app?.savedDataBeforeRedirecting?.[
              `emailSendDataToBeSaved`
            ]
          )?.length > 0
        ) {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
          });
        } else {
          this.setAttachments();
          this.setMessage();
        }
      }
    );
  };

  public setAttachments = () => {
    switch (this.state.entityName) {
      case 'statement':
        this.props.dispatch({
          type: Constants.GLOBAL_ATTACHMENT_LIST,
          payload: {
            financialStatementId: this.state.selectedEntityForEmail?.id,
            // TODO fix hardcoded values
            language: this.state.languageForPdf === 'en-US' ? 1 : 2,
          },
          onSuccess: (attachments) => {
            this.setState({
              attachments: [...attachments],
              attachmentIds: attachments.map((attachment) => attachment.id),
              selectedAttachmentsIds: attachments
                ?.filter((attachment) => attachment?.automaticallyCreated)
                ?.map((attachment) => attachment.id),
            });
          },
        });
        break;
      case 'charge':
      case 'task':
        let attachments = this.state.selectedEntityForEmail?.attachments
          ? this.state.selectedEntityForEmail?.attachments
          : [];

        if (this.state.selectedEntityForEmail?.conversationId) {
          const conversation = this.props.app.conversations.find(
            (c) => c.id === this.state.selectedEntityForEmail?.conversationId
          );
          if (conversation?.attachments?.length) {
            attachments = [...conversation?.attachments, ...attachments];
          }
        }
        this.setState({
          attachments: [...attachments],
          attachmentIds: attachments.map((attachment) => attachment.id),
          selectedAttachmentsIds:
            this.state.selectedAttachmentsIds ||
            attachments
              ?.filter((attachment) => attachment?.automaticallyCreated)
              ?.map((attachment) => attachment.id),
        });
        break;
      // case "renewed-contract":
      case 'contract':
      case 'new-contract':
        this.props.dispatch({
          type: Constants.GLOBAL_ATTACHMENT_LIST,
          payload: {
            contractId: this.state.selectedEntityForEmail?.id,
            type: this.state.firstInvoice,
          },
          onSuccess: (attachments) => {
            this.setState({
              attachments: [...attachments],
              attachmentIds: attachments.map((attachment) => attachment.id),
              selectedAttachmentsIds: attachments
                ?.filter((attachment) => attachment?.automaticallyCreated)
                ?.map((attachment) => attachment.id),
            });
          },
        });
        break;
    }
  };

  public setMessage = (init: boolean = false) => {
    let messageBeginning = this.state.emailToPersonName
      ? `${this.trans(
          'page/sendemail-message/hello',
          {},
          this.state.languageForPdf
        )} ${this.state.emailToPersonName},`
      : '';

    if (
      this.state.entityName === 'contract' ||
      this.state.entityName === 'new-contract' ||
      this.state.entityName === 'renewed-contract'
    ) {
      messageBeginning = this.state.emailToPersonName
        ? `${this.trans(
            'page/sendemail-message/dear',
            {},
            this.state.languageForPdf
          )} ${this.state.emailToPersonName},`
        : '';
    }

    const senderName = this.state.useAgencyNameForEmail
      ? this.getAgency()?.name
      : `${this.props.app?.session?.user?.firstName} ${
          this.props.app?.session?.user?.lastName
        } (${this.getAgency()?.name})`;
    let message = '';

    if (!init) {
      switch (this.state.entityName) {
        case 'statement':
          message = `${messageBeginning ? `${messageBeginning}\n\n` : '\n\n'}${
            this.state.languageForPdf === 'en-US'
              ? this.props.app?.settings?.agency?.statementEmailTextEn
              : this.props.app?.settings?.agency?.statementEmailTextNl
          }\n\n${senderName}`;
          break;
        case 'charge':
          let messageKey = 'page/sendemail-message/invoice';

          if (this.state.sendReminder) {
            if (this.state.selectedEntityForEmail?.amountPaid === 0) {
              messageKey = 'page/sendemail-message/chargeunpaid';
            } else {
              messageKey = 'page/sendemail-message/chargepartlypaid';
            }
          }

          message = `${
            messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
          }${this.trans(
            messageKey,
            {},
            this.state.languageForPdf
          )}\n\n${senderName}`;
          break;
        case 'payment':
          message = `${
            messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
          }${this.trans(
            'page/sendemail-message/payment',
            {},
            this.state.languageForPdf
          )}\n\n${senderName}`;
          break;
        case 'task':
          // const description = this.state.selectedEntityForEmail?.content?.name
          // const object = this.state.selectedEntityForEmail?.unit?.shortDisplayName || this.state.selectedEntityForEmail?.unit?.displayName
          const contact =
            this.state.selectedEntityForEmail?.unit?.getActiveContract()
              ?.tenant;
          const name = contact
            ? `${this.trans('label-name', {}, this.state.languageForPdf)}: ${
                contact?.displayName
              }\n\n`
            : '';
          const email = contact?.email
            ? `${this.trans('title-email', {}, this.state.languageForPdf)}: ${
                contact?.email
              }\n\n`
            : '';
          const phone1 = contact?.phone1
            ? `${this.trans('phone', {}, this.state.languageForPdf)}: ${
                contact?.phone1
              }\n\n`
            : '';
          const contactsPart = `${name ? name : ''}${email ? email : ''}${
            phone1 ? phone1 : ''
          }`;
          message = `${
            messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
          }${this.trans(
            'page/sendemail-message/task',
            {},
            this.state.languageForPdf
          )}\n\n${contactsPart}${senderName}`;
          break;
        case 'contract':
          if (!this.state.firstInvoice) {
            message = `${
              messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
            }${
              this.state.firstInvoice === 'first'
                ? this.trans(
                    'page/sendemail-message1/collectiveinvoice',
                    {
                      unitDisplayName:
                        this.state.selectedEntityForEmail?.unit?.displayName,
                    },
                    this.state.languageForPdf
                  )
                : this.trans(
                    'page/sendemail-message1/lastcollectiveinvoice',
                    {
                      unitDisplayName:
                        this.state.selectedEntityForEmail?.unit?.displayName,
                    },
                    this.state.languageForPdf
                  )
            }\n${this.trans(
              'page/sendemail-message3/collectiveinvoice',
              {},
              this.state.languageForPdf
            )}\n\n${senderName}`;
          }
          message = `${
            messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
          }${this.trans(
            'page/sendemail-message/contract',
            {},
            this.state.languageForPdf
          )}\n\n\n${senderName}`;
          break;
        case 'new-contract':
          const relatedObject = `${this.trans(
            'object',
            {},
            this.state.languageForPdf
          )}: ${this.state.selectedEntityForEmail?.unit?.displayName}`;
          const tenant = `${this.trans(
            'tenant',
            {},
            this.state.languageForPdf
          )}: ${
            this.state.selectedEntityForEmail?.unit?.getActiveContract()?.tenant
              .displayName
          }`;
          let messageHeader;
          messageHeader =
            this.state.languageForPdf === 'nl-NL'
              ? this.props.app?.settings?.agency?.adjustRentEmailTextNL
              : this.props.app?.settings?.agency?.adjustRentEmailTextEN;
          const oldContract = this.props.app.contracts.find(
            (contract) =>
              contract.id ===
              this.state.selectedEntityForEmail.previousContractId
          );
          const oldPrices = oldContract?.chargeTemplates
            ?.filter((template) => template.repeatPeriod.id !== 1)
            .map((template) => ({
              amount: template.amount,
              currency: template.currency,
            }));
          const newPrices =
            this.state.selectedEntityForEmail?.chargeTemplates?.map(
              (template) => ({
                amount: template.amount,
                currency: template.currency,
              })
            );
          const totalOldPrice = oldPrices?.reduce((a, b) => a + b.amount, 0);
          const totalNewPrice = newPrices?.reduce((a, b) => a + b.amount, 0);
          const oldPricesTotal = `${this.formatter.formatNumber(
            totalOldPrice
          )}`;
          const newPricesTotal = `${this.formatter.formatNumber(
            totalNewPrice
          )}`;
          const newContractStartDate =
            this.formatter.formatDateDependsOnLanguage(
              this.state.selectedEntityForEmail?.firstDate,
              this.state.languageForPdf
            );
          const oldContractEndDate = this.formatter.formatDateDependsOnLanguage(
            oldContract?.endDate,
            this.state.languageForPdf
          );

          const oldPricesMessage = `${this.trans(
            'page/sendemail-message/rent-until',
            { oldContractEndDate },
            this.state.languageForPdf
          )}\n${this.trans(
            'label-monthly',
            {},
            this.state.languageForPdf
          )}: ${oldPricesTotal} ${oldPrices?.[0]?.currency?.getIso()}`;
          const newPricesMessage = `${this.trans(
            'page/sendemail-message/rent-after',
            { newContractStartDate },
            this.state.languageForPdf
          )}\n${this.trans(
            'label-monthly',
            {},
            this.state.languageForPdf
          )}: ${newPricesTotal} ${newPrices?.[0]?.currency?.getIso()}`;
          const messageEnding = this.trans(
            'page/sendemail-message/message-ending',
            {},
            this.state.languageForPdf
          );
          const messageHeaderNewContract = `${
            messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
          }`;
          message = `${messageHeaderNewContract}${
            messageHeader ? `${messageHeader}\n\n` : ''
          }${relatedObject}\n${tenant}\n\n${oldPricesMessage}\n\n${newPricesMessage}\n\n${messageEnding}\n\n${this.trans(
            'page/sendemail-message3/renewed-contract',
            {},
            this.state.languageForPdf
          )}\n${senderName}`;

          break;
        case 'statements-request-review':
          let domain = 'app.casadesk.com';

          if (Environment.isStaging()) {
            domain = 'casadesk-frontend-stg.herokuapp.com';
          } else if (Environment.isDevelopment()) {
            domain = 'casadesk-frontend-qa.herokuapp.com';
          }

          message = `${
            messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
          }${this.trans(
            'page/sendemail-message/requeststatementsreview',
            { domain: domain },
            this.state.languageForPdf
          )}\n\n${senderName}`;
          break;
        case 'tenant-login-portal-link':
          message = `${
            messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
          }${this.trans(
            'page/sendemail-message/tenant-login-portal-link',
            { agencyName: this.getAgency()?.name },
            this.state.languageForPdf
          )}\n\n${senderName}`;
          break;
        case 'renewed-contract':
          const messageHeaderToRenew = `${
            messageBeginning ? `${messageBeginning}\n\n` : '\n\n'
          }${this.trans(
            'page/sendemail-message/renewed-contract',
            {},
            this.state.languageForPdf
          )}`;
          const relatedObjectToRenew = `${this.trans(
            'object',
            {},
            this.state.languageForPdf
          )}: ${this.state.selectedEntityForEmail?.unit?.displayName}`;
          const tenantToRenew = `${this.trans(
            'tenant',
            {},
            this.state.languageForPdf
          )}: ${
            this.state.selectedEntityForEmail?.unit?.getActiveContract()?.tenant
              .displayName
          }`;
          // let messageHeaderToRenew;
          // messageHeaderToRenew = this.state.languageForPdf === 'nl-NL' ? this.props.app?.settings?.agency?.adjustRentEmailTextNL : this.props.app?.settings?.agency?.adjustRentEmailTextEN
          const oldContractToRenew = this.props.app.contracts.find(
            (contract) =>
              contract.id ===
              this.state.selectedEntityForEmail.previousContractId
          );
          const oldPricesToRenew = oldContractToRenew?.chargeTemplates
            ?.filter((template) => template.repeatPeriod.id !== 1)
            .map((template) => ({
              amount: template.amount,
              currency: template.currency,
              type: template?.type?.id,
            }));

          const newPricesToRenew =
            this.state.selectedEntityForEmail?.chargeTemplates?.map(
              (template) => ({
                amount: template.amount,
                currency: template.currency,
                type: template?.type?.id,
              })
            );
          const totalOldPriceToRenew = oldPricesToRenew?.reduce(
            (a, b) => a + b.amount,
            0
          );
          const totalNewPriceToRenew = newPricesToRenew?.reduce(
            (a, b) => a + b.amount,
            0
          );
          const oldPricesTotalToRenew = `${this.formatter.formatNumber(
            totalOldPriceToRenew
          )}`;
          const newPricesTotalToRenew = `${this.formatter.formatNumber(
            totalNewPriceToRenew
          )}`;
          const newContractStartDateToRenew =
            this.formatter.formatDateDependsOnLanguage(
              this.state.selectedEntityForEmail?.firstDate,
              this.state.languageForPdf
            );
          const oldContractEndDateToRenew =
            this.formatter.formatDateDependsOnLanguage(
              oldContractToRenew?.endDate,
              this.state.languageForPdf
            );

          const oldAgreementAmount =
            this.state.agencyFee?.fixedFee / 100 +
              (this.state.agencyFee?.percentageFee / 100) *
                oldPricesToRenew
                  ?.filter((price) =>
                    this.state.agencyFee?.chargeTypeIds.includes(price?.type)
                  )
                  .reduce((a, b) => a + b.amount, 0) / 100 || 0;
          const newAgreementAmount =
            this.state.agencyFee?.fixedFee / 100 +
              (this.state.agencyFee?.percentageFee / 100) *
                newPricesToRenew
                  ?.filter((price) =>
                    this.state.agencyFee?.chargeTypeIds.includes(price?.type)
                  )
                  .reduce((a, b) => a + b.amount, 0) / 100 || 0;

          const oldPricesMessageToRenew = oldContractToRenew?.endDate
            ? `\n${this.trans(
                'page/sendemail-message/rent-until',
                { oldContractEndDate: oldContractEndDateToRenew },
                this.state.languageForPdf
              )}\n${this.trans(
                'label-monthly',
                {},
                this.state.languageForPdf
              )}: ${oldPricesTotalToRenew} ${oldPricesToRenew?.[0]?.currency?.getIso()}\n`
            : '';
          const newPricesMessageToRenew = `${this.trans(
            'page/sendemail-message/rent-after',
            { newContractStartDate: newContractStartDateToRenew },
            this.state.languageForPdf
          )}\n${this.trans(
            'label-monthly',
            {},
            this.state.languageForPdf
          )}: ${newPricesTotalToRenew} ${newPricesToRenew?.[0]?.currency?.getIso()}`;

          const oldAgreementPricesMessageToRenew = oldAgreementAmount
            ? `\n${this.trans(
                'page/sendemail-message/agreement-until',
                { oldContractEndDate: oldContractEndDateToRenew },
                this.state.languageForPdf
              )}\n${this.trans(
                'label-monthly',
                {},
                this.state.languageForPdf
              )}: ${oldAgreementAmount} ${oldPricesToRenew?.[0]?.currency?.getIso()}\n`
            : '';
          const newAgreementPricesMessageToRenew = `${this.trans(
            'page/sendemail-message/agreement-after',
            { newContractStartDate: newContractStartDateToRenew },
            this.state.languageForPdf
          )}\n${this.trans(
            'label-monthly',
            {},
            this.state.languageForPdf
          )}: ${newAgreementAmount} ${newPricesToRenew?.[0]?.currency?.getIso()}`;

          message = `${
            messageHeaderToRenew ? `${messageHeaderToRenew}\n\n` : ''
          }${relatedObjectToRenew}\n${tenantToRenew}\n${oldPricesMessageToRenew}\n${newPricesMessageToRenew}\n${oldAgreementPricesMessageToRenew}\n${newAgreementPricesMessageToRenew}\n\n${this.trans(
            'page/sendemail-message3/renewed-contract',
            {},
            this.state.languageForPdf
          )}\n${senderName}`;

          break;
      }
    } else {
      // logic to change only message beginning and keep message body when user changes the email
      if (
        this.state.messageBeginning &&
        this.state.messageBeginning ===
          this.state.message.substring(0, this.state.messageBeginning?.length)
      ) {
        message =
          messageBeginning +
          this.state.message.substring(this.state.messageBeginning?.length);
      } else if (!this.state.messageBeginning) {
        message = messageBeginning + this.state.message;
      }
    }

    this.setState({
      message: message,
      messageBeginning: messageBeginning,
      footerText: senderName,
    });
  };

  public onChange = (valArray) => {
    const emails = !!valArray ? valArray.map((item) => item.value) : [];
    const emailList = this.props.app.persons.filter(
      (person) => !person.removed && !!person.email
    );
    const languageChoice = emailList?.find(
      (item) => item?.email === emails[0]
    )?.languageTypeId;

    this.setState(
      {
        emailTo: emails.length > 0 ? emails[0] : '',
        emailsCC: emails.length > 1 ? emails.slice(1) : [],
        emailToPersonName: emails[0]
          ? emailList
              ?.find((item) => item?.email === emails[0])
              ?.firstName?.trim()
          : '',
        hasModifiedData: true,
        languageForPdf: languageChoice === 1 ? 'en-US' : 'nl-NL',
      },
      () => {
        this.setMessage(this.state.messageManuallyChanged);
        this.setAttachments();
      }
    );
  };

  public switchUseAgencyEmailNameForEmail = () => {
    const oldFooterTextIndex = this.state.message?.lastIndexOf(
      this.state.footerText
    );
    const newFooterText = !this.state.useAgencyNameForEmail
      ? this.getAgency()?.name
      : `${this.props.app?.session?.user?.firstName} ${
          this.props.app?.session?.user?.lastName
        } (${this.getAgency()?.name})`;
    const state: any = {
      useAgencyNameForEmail: !this.state.useAgencyNameForEmail,
      footerText: !this.state.useAgencyNameForEmail
        ? this.getAgency()?.name
        : `${this.props.app?.session?.user?.firstName} ${
            this.props.app?.session?.user?.lastName
          } (${this.getAgency()?.name})`,
    };

    // logic to change only message footer and keep message body when user switches "use agency email"
    if (
      this.state.footerText === this.state.message.substring(oldFooterTextIndex)
    ) {
      state.message =
        this.state.message.substring(0, oldFooterTextIndex) + newFooterText;
    }

    this.setState(
      {
        ...state,
      },
      () => {
        this.saveSettings();
      }
    );
  };

  public switchSendCopyTo = () => {
    this.setState({
      sendCopyTo: !this.state.sendCopyTo,
    });
  };

  public saveSettings = (): any => {
    return this.props.dispatch({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_START,
      payload: {
        preferences: {
          useAgencyNameForEmail: this.state.useAgencyNameForEmail,
        },
        hideSnackbar: true,
      },
    });
  };

  public onAttachmentSelect = (attachmentIds) => {
    this.setState({
      // attachmentIds: [...attachmentIds],
      selectedAttachmentsIds: [...attachmentIds],
    });
  };

  public getTemplateId(entity) {
    switch (entity) {
      case 'charge':
        return {
          subject: `${this.trans('charge', {}, this.state.languageForPdf)} ${
            this.state.selectedEntityForEmail?.chargeClass.id === 1
              ? this.trans('to-lowercase', {}, this.state.languageForPdf)
              : this.trans('from-lowercase', {}, this.state.languageForPdf)
          } ${this.state.selectedEntityForEmail?.name || ''} ${
            this.state.selectedEntityForEmail?.hasSavingsType
              ? `(${this.trans(
                  'charge/payment-summary-title/savings',
                  {},
                  this.state.languageForPdf
                )})`
              : ''
          }`,
          chargeId: this.state.selectedEntityForEmail.id,
          title: this.trans('title-charge', {}, this.state.languageForPdf),
          ...this.getChargeDetails(),
        };

      case 'payment':
        return {
          subject: `${this.trans('payment', {}, this.state.languageForPdf)} ${
            this.state.selectedEntityForEmail?.paymentClass.id === 1
              ? this.trans('to-lowercase', {}, this.state.languageForPdf)
              : this.trans('from-lowercase', {}, this.state.languageForPdf)
          } ${this.state.selectedEntityForEmail?.getPayerDisplayName()} ${
            this.state.selectedEntityForEmail?.hasSavingsType
              ? `(${this.trans(
                  'charge/payment-summary-title/savings',
                  {},
                  this.state.languageForPdf
                )})`
              : ''
          }`,
          paymentId: this.state.selectedEntityForEmail.id,
          title: this.trans('title-payment', {}, this.state.languageForPdf),
          ...this.getPaymentDetails(),
        };
      case 'new-contract':
        return {
          contractId: this.state.selectedEntityForEmail.id,
          subject: `${this.trans(
            'email/subject-rent-adjust',
            {},
            this.state.languageForPdf
          )} ${
            this.state.selectedEntityForEmail?.unit?.shortDisplayName
              ? this.state.selectedEntityForEmail?.unit?.shortDisplayName
              : this.state.selectedEntityForEmail?.unit?.displayName
          }`,
          templateId: 'sendContractDetailsPdf',
        };
      case 'renewed-contract':
        return {
          contractId: this.state.selectedEntityForEmail.id,
          subject: `${this.trans(
            'email/subject-rent-adjust',
            {},
            this.state.languageForPdf
          )} ${
            this.state.selectedEntityForEmail?.unit?.shortDisplayName
              ? this.state.selectedEntityForEmail?.unit?.shortDisplayName
              : this.state.selectedEntityForEmail?.unit?.displayName
          }`,
          templateId: 'sendRenewedContractDetailsPdf',
        };
      case 'statement':
        return {
          subject: `${this.trans(
            'send-invoice-subject',
            {},
            this.state.languageForPdf
          )} ${Time.useFormatForUserLanguage(
            this.state.selectedEntityForEmail?.firstDate,
            this.state.languageForPdf,
            'MMMM YYYY'
          )}`,
        };
      default:
        return {};
    }
  }

  public save = () => {
    const email: any = {
      to: this.state.emailTo,
      cc: this.state.emailsCC,
      message: this.state.message,
      attachmentIds: this.state.selectedAttachmentsIds,
      language: this.state.languageForPdf === 'en-US' ? 'EN' : 'NL',
      from: this.props.app?.session?.user?.email,
      entity: this.state.entityName,
      agencyName: this.getAgency()?.name,
      currency: this.state.selectedEntityForEmail?.currency?.getIso(),
      data: { ...this.getTemplateId(this.state.entityName) },
    };

    if (this.state.selectedEntityForEmail instanceof Property) {
      email.propertyId = this.state.selectedEntityForEmail.id;
    }

    if (this.state.selectedEntityForEmail instanceof Unit) {
      email.unitId = this.state.selectedEntityForEmail.id;
    }

    if (this.state.selectedEntityForEmail instanceof Contract) {
      email.contractId = this.state.selectedEntityForEmail.id;
    }

    if (this.state.selectedEntityForEmail instanceof Company) {
      email.companyId = this.state.selectedEntityForEmail.id;
    }

    if (this.state.selectedEntityForEmail instanceof Person) {
      email.contactId = this.state.selectedEntityForEmail.id;
    }
    //better not to delete commented ifs until the logic will be change completely
    // if (this.state.selectedEntityForEmail instanceof Charge) {
    //   email.chargeId = this.state.selectedEntityForEmail.id;
    //   email.subject = `${this.trans("charge")} ${this.trans("from-lowercase")} ${this.state.selectedEntityForEmail?.name || ""} ${this.state.selectedEntityForEmail?.hasSavingsType ? `(${this.trans("charge/payment-summary-title/savings")})` : ""}`;
    // }

    // if (this.state.selectedEntityForEmail instanceof Payment) {
    //   email.paymentId = this.state.selectedEntityForEmail.id;
    //   email.subject = `${this.trans("charge")} ${this.trans("to-lowercase")} ${this.state.selectedEntityForEmail?.getPayerDisplayName()}	${this.state.selectedEntityForEmail?.hasSavingsType ? `(${this.trans("charge/payment-summary-title/savings")})` : ""}`;
    // }

    if (this.state.selectedEntityForEmail instanceof Event) {
      email.eventId = this.state.selectedEntityForEmail.id;
    }

    if (this.state.entityName === 'statement') {
      email.financialStatementId = this.state.selectedEntityForEmail?.id;
      email.sendCopyTo = this.state.sendCopyTo;
      email.sendCopyToEmails = this.state.sendCopyToEmails;
      email.sendCopyToSubject = this.state.sendCopyToSubject;
      email.sendCopyToMessage = `${this.trans(
        'page/sendemail-message/sendcopytomessage',
        {},
        this.state.languageForPdf
      )}\n\n${
        this.state.useAgencyNameForEmail
          ? this.getAgency()?.name
          : `${this.props.app?.session?.user?.firstName} ${
              this.props.app?.session?.user?.lastName
            } (${this.getAgency()?.name})`
      }`;
      email.templateId = 'sendInvoicePdf';
    }

    if (this.state.entityName === 'statements-request-review') {
      email.statementsRequestReview = true;
    }

    if (this.state.entityName === 'tenant-login-portal-link') {
      email.sendInvite = true;
      email.contactId = this.state.selectedEntityForEmail?.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EMAIL_SEND_START,
        payload: {
          ...email,
        },
        onSuccess: this.redirectBack,
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false,
            isNotValidTo: true,
          });
        },
      });
    });
  };

  public onDiscard = () => {
    this.setState({ openLeavePrompt: false }, this.leave.bind(this));
  };

  public openCancelDialog = () => {
    this.setState({ openLeavePrompt: true });
  };

  public onChangeSendCopyToEmails = (valArray = []) => {
    const emails = !!valArray ? valArray.map((item) => item.value) : [];

    this.setState({
      sendCopyToEmails: emails,
      hasModifiedData: true,
    });
  };

  public getChargeDetails = () => {
    let templateId: string,
      counterpartyHeader: string,
      counterparty: string,
      chargeObject: string,
      chargeType: string,
      chargeDescription: string,
      dueDate: string,
      chargePeriod: string,
      statement: string,
      invoiceDate: string,
      invoiceNumber: string,
      vat: string,
      collectiveVat: { percentage: number; totalVatAmount: number }[],
      amount: string,
      percentage: string | 0;

    templateId = 'sendInvoice';
    counterpartyHeader = `${
      this.state.selectedEntityForEmail?.chargeClass.id === 1
        ? this.trans('charge-class-receivable', {}, this.state.languageForPdf)
        : this.trans('charge-class-payable', {}, this.state.languageForPdf)
    }:`;
    counterparty = `${this.state.selectedEntityForEmail?.name || ''} ${
      this.state.selectedEntityForEmail?.hasSavingsType
        ? `(${this.trans(
            'charge/payment-summary-title/savings',
            {},
            this.state.languageForPdf
          )})`
        : ''
    }`;
    amount = `${this.formatter.formatNumber(
      this.state.selectedEntityForEmail?.amount
    )} ${this.state.selectedEntityForEmail?.currency?.getIso()}`;
    chargeObject =
      this.state.selectedEntityForEmail?.relatedEntity?.displayName;
    chargeType = this.trans(
      this.state.selectedEntityForEmail?.type?.label,
      {},
      this.state.languageForPdf
    );
    chargeDescription = `${this.trans(
      this.state.selectedEntityForEmail?.type?.label,
      {},
      this.state.languageForPdf
    )}, ${Time.useFormatForUserLanguage(
      this.state.selectedEntityForEmail?.financialStatement?.firstDate,
      this.state.languageForPdf,
      'MMMM'
    )}`;
    dueDate = this.formatter.formatDateDependsOnLanguage(
      this.state.selectedEntityForEmail?.dueDate,
      this.state.languageForPdf
    );
    chargePeriod = `${Time.formatTwoDatesPeriodForLanguage(
      this.state.selectedEntityForEmail?.dateOfPeriod,
      this.state.selectedEntityForEmail?.lastDate,
      this.state.languageForPdf
    )}`;
    statement = `${Time.useFormatForUserLanguage(
      this.state.selectedEntityForEmail?.financialStatement?.firstDate,
      this.state.languageForPdf,
      'MMMM YYYY'
    )}`;
    (invoiceDate = this.state.selectedEntityForEmail?.isInvoice
      ? this.formatter.formatDateDependsOnLanguage(
          this.state.selectedEntityForEmail?.invoiceDate,
          this.state.languageForPdf
        )
      : ''),
      (invoiceNumber = this.state.selectedEntityForEmail?.isInvoice
        ? this.state.selectedEntityForEmail?.invoiceNumber
        : '');
    vat = this.formatter.formatNumber(
      this.state.selectedEntityForEmail?.vat,
      this.state.selectedEntityForEmail?.currency
    );
    collectiveVat = this.state.selectedEntityForEmail?.collectiveVat.map(
      (vat) => ({ ...vat, totalVatAmount: vat.totalVatAmount / 100 })
    );
    percentage = isNaN(
      (this.state.selectedEntityForEmail?.vat /
        (this.state.selectedEntityForEmail?.amount -
          this.state.selectedEntityForEmail?.vat)) *
        100
    )
      ? 0
      : Math.round(
          (this.state.selectedEntityForEmail?.vat /
            (this.state.selectedEntityForEmail?.amount -
              this.state.selectedEntityForEmail?.vat)) *
            100
        ).toFixed(0);

    return {
      templateId: templateId,
      counterpartyHeader: counterpartyHeader,
      counterparty: counterparty,
      amount: amount,
      chargeObject: chargeObject,
      chargeType: chargeType,
      chargeDescription: chargeDescription,
      dueDate: dueDate,
      chargePeriod: chargePeriod,
      statement: statement,
      invoiceDate: invoiceDate,
      invoiceNumber: invoiceNumber,
      vat:
        this.state.selectedEntityForEmail?.vat !== 0 ||
        (this.state.selectedEntityForEmail?.isInvoice &&
          !this.state.selectedEntityForEmail?.hasPayoutType)
          ? { vat: vat, percentage: percentage }
          : '',
      percentage: percentage,
      collectiveVat: collectiveVat,
    };
  };

  public renderChargeDetails = (charge: ChargeInterface) => {
    return (
      <div className="charge-details-readonly">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <table>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('label-amount')}:`}
              </td>
              <td className="align-left">
                {this.formatter.formatNumber(charge?.amount)}{' '}
                {charge?.currency?.getIso()}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('object')}:`}
              </td>
              <td className="align-left">
                {charge?.relatedEntity?.displayName}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${
                  this.state.selectedEntityForEmail?.chargeClass.id === 1
                    ? this.trans('charge-class-receivable')
                    : this.trans('charge-class-payable')
                }:`}
              </td>
              <td className="align-left">
                {`${charge?.name || ''} ${
                  charge?.hasSavingsType
                    ? `(${this.trans('charge/payment-summary-title/savings')})`
                    : ''
                }`}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('label-type')}:`}
              </td>
              <td className="align-left">
                {this.formatter.checkTranslationType(
                  this.trans(charge?.type?.label, {}, '', charge?.type?.system),
                  charge?.type?.label,
                  charge?.type?.system
                )}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('description')}:`}
              </td>
              <td className="align-left">
                {`${this.formatter.checkTranslationType(
                  this.trans(charge?.type?.label, {}, '', charge?.type?.system),
                  charge?.type?.label,
                  charge?.type?.system
                )}, ${Time.useFormatForUserLanguage(
                  charge?.dueDate,
                  this.props?.app?.settings?.user?.language?.iso,
                  'MMMM'
                )}`}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('due-date')}:`}
              </td>
              <td className="align-left">
                {this.formatter.formatDate(charge?.dueDate)}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {this.trans('charge-summary-details/period')}
              </td>
              <td className="align-left">
                {`${Time.formatTwoDatesPeriodForLanguage(
                  charge?.dateOfPeriod,
                  charge?.lastDate,
                  this.props?.app?.settings?.user?.language?.iso
                )}`}
              </td>
            </tr>
            {!!charge?.financialStatement &&
              // CASA-7791
              charge?.ownerId !== this.getAgency()?.id &&
              !isDirectPaymentRoute(charge?.paymentRouteId) && (
                <tr>
                  <td className="align-left first-column">
                    {this.trans('charge-summary-details/ownerstatement')}
                  </td>
                  <td className="align-left">
                    {`${Time.useFormatForUserLanguage(
                      charge?.firstDate,
                      this.props?.app?.settings?.user?.language?.iso,
                      'MMMM YYYY'
                    )}`}
                  </td>
                </tr>
              )}
            {charge?.isInvoice && charge?.invoiceDate && (
              <tr>
                <td className="align-left first-column">
                  {`${this.trans('section/charge-field/invoicedate-label')}:`}
                </td>
                <td className="align-left">
                  {this.formatter.formatDate(charge?.invoiceDate)}
                </td>
              </tr>
            )}
            {charge?.isInvoice && charge?.invoiceNumber && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('charge-summary-details/invoicenumber')}
                </td>
                <td className="align-left">{charge?.invoiceNumber}</td>
              </tr>
            )}
            {charge?.isInvoice && !charge?.hasPayoutType && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('label-vat')}{' '}
                  {isNaN((charge?.vat / (charge?.amount - charge?.vat)) * 100)
                    ? 0
                    : this.formatter.simpleFormatNumber(
                        Math.round(
                          (charge?.vat / (charge?.amount - charge?.vat)) * 100
                        ),
                        false,
                        false
                      )}
                  %
                </td>
                <td className="align-left">
                  {this.formatter.formatNumber(charge?.vat, charge?.currency)}
                </td>
              </tr>
            )}
            {charge?.isInvoice &&
              charge?.hasPayoutType &&
              charge?.collectiveVat?.map((vat) => {
                return (
                  <tr>
                    <td className="align-left first-column">
                      {this.trans('label-vat')} {vat?.percentage}%
                    </td>
                    <td className="align-left">
                      {this.formatter.formatNumber(
                        vat?.totalVatAmount,
                        charge?.currency
                      )}
                    </td>
                  </tr>
                );
              })}
          </table>
        </div>
      </div>
    );
  };
  public renderContractDetails = (contract: ContractInterface) => {
    return (
      <div className="charge-details-readonly">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <table>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('unit')}:`}
              </td>
              <td className="align-left">
                {contract?.unit?.shortDisplayName
                  ? contract?.unit?.shortDisplayName
                  : contract?.unit?.displayName}
              </td>
            </tr>
            {contract?.tenant && (
              <tr>
                <td className="align-left first-column">
                  {`${this.trans('tenant')}:`}
                </td>
                <td className="align-left">{contract?.tenant?.displayName}</td>
              </tr>
            )}
            {contract?.firstDate && (
              <tr>
                <td className="align-left first-column">
                  {`${this.trans('first-date')}:`}
                </td>
                <td className="align-left">
                  {this.formatter.formatDate(contract?.firstDate)}
                </td>
              </tr>
            )}
            {contract?.lastDate && (
              <tr>
                <td className="align-left first-column">
                  {`${this.trans('expiration-date')} 1:`}
                </td>
                <td className="align-left">
                  {this.formatter.formatDate(contract?.lastDate)}
                </td>
              </tr>
            )}
            {contract?.finalRentalPeriodDate && (
              <tr>
                <td className="align-left first-column">
                  {`${this.trans('expiration-date')} 2:`}
                </td>
                <td className="align-left">
                  {this.formatter.formatDate(contract?.finalRentalPeriodDate)}
                </td>
              </tr>
            )}
            {contract?.endDate && (
              <tr>
                <td className="align-left first-column">
                  {`${this.trans('end-date')}:`}
                </td>
                <td className="align-left">
                  {this.formatter.formatDate(contract?.endDate)}
                </td>
              </tr>
            )}
          </table>
        </div>
      </div>
    );
  };

  public renderTaskDetails = () => {
    const description = this.state.selectedEntityForEmail?.content?.name;
    const object =
      this.state.selectedEntityForEmail?.unit?.shortDisplayName ||
      this.state.selectedEntityForEmail?.unit?.displayName;

    return (
      <div className="charge-details-readonly">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <table>
            <tr>
              <td className="align-left" style={{ fontWeight: 'bold' }}>
                {this.trans('task', {}, this.state.languageForPdf)}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('page/taskupdate-hint/object')}`}
              </td>
              <td className="align-left">{object}</td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('description')}:`}
              </td>
              <td className="align-left">{description}</td>
            </tr>
          </table>
        </div>
      </div>
    );
  };

  public getPaymentDetails = () => {
    let templateId: string,
      date: string,
      amount: string,
      counterpartyHeader: string,
      counterparty: string,
      description: string,
      transaction: string;

    const payment = this.state.selectedEntityForEmail;
    const baseAccount = getPaymentBaseAccountDisplay({
      payment,
      agencyBankAccounts: this.getAgencyBankAccounts(),
      companies: this.props.app?.companies,
      agencyId: this.getAgency()?.id,
    });
    const hasParsedTransactionDescription =
      payment?.parsedTransactionDescription &&
      Object.keys(payment?.parsedTransactionDescription || {}).length > 0;
    const parsedTransactionDescriptionArray = [];

    if (hasParsedTransactionDescription) {
      for (let description in payment?.parsedTransactionDescription) {
        parsedTransactionDescriptionArray.push(
          `${description}: ${payment?.parsedTransactionDescription[description]}`
        );
      }
    }

    templateId = 'sendPayment';
    date = this.formatter.formatDateDependsOnLanguage(
      payment?.dateOfThePayment,
      this.state.languageForPdf
    );
    amount = `${this.formatter.formatNumber(
      payment?.amount
    )} ${payment?.currency?.getIso()}`;
    counterpartyHeader = payment?.isPaid
      ? this.trans('label-received-from', {}, this.state.languageForPdf)
      : this.trans('label-paid-to', {}, this.state.languageForPdf);
    counterparty = payment?.isPaid
      ? `${baseAccount.accountId} ${baseAccount.name}`
      : `${payment?.mainBankAccountId} ${payment?.name}`;
    description = payment?.description;
    transaction = parsedTransactionDescriptionArray.join('\n');

    return {
      templateId: templateId,
      date: date,
      amount: amount,
      counterpartyHeader: counterpartyHeader,
      counterparty: counterparty,
      description: description,
      transaction: transaction,
    };
  };

  public renderPaymentDetails = (payment: PaymentInterface) => {
    const baseAccount = getPaymentBaseAccountDisplay({
      payment,
      agencyBankAccounts: this.getAgencyBankAccounts(),
      companies: this.props.app?.companies,
      agencyId: this.getAgency()?.id,
    });
    const hasParsedTransactionDescription =
      payment?.parsedTransactionDescription &&
      Object.keys(payment?.parsedTransactionDescription || {}).length > 0;
    const parsedTransactionDescriptionArray = [];

    if (hasParsedTransactionDescription) {
      for (let description in payment?.parsedTransactionDescription) {
        parsedTransactionDescriptionArray.push(
          `${description}: ${payment?.parsedTransactionDescription[description]}`
        );
      }
    }

    return (
      <div className="payment-details-readonly">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <table>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('date')}:`}
              </td>
              <td className="align-left">
                {this.formatter.formatDate(payment?.dateOfThePayment)}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {`${this.trans('label-amount')}:`}
              </td>
              <td className="align-left">
                {this.formatter.formatNumber(payment?.amount)}{' '}
                {payment?.currency?.getIso()}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {payment?.isPaid
                  ? this.trans('label-received-from')
                  : this.trans('label-paid-to')}
              </td>
              <td className="align-left">
                {payment?.isReceived && (
                  <div>
                    {payment?.mainBankAccountId}
                    <span style={{ marginLeft: '5px', color: '#ababab' }}>
                      {payment?.name}
                    </span>
                  </div>
                )}
                {payment?.isPaid && (
                  <div>
                    {baseAccount.accountId}
                    <span style={{ marginLeft: '5px', color: '#ababab' }}>
                      {baseAccount.name}
                    </span>
                  </div>
                )}
              </td>
            </tr>
            <tr>
              <td className="align-left first-column">
                {this.trans('payment-summary-details/description')}
              </td>
              <td className="align-left">{payment?.description}</td>
            </tr>
            {payment?.hasTransaction && (
              <tr>
                <td className="align-left first-column">
                  {this.trans('payment-summary-details/transactiondetails')}
                </td>
                <td className="align-left">
                  {parsedTransactionDescriptionArray.map((description) => (
                    <div>{description}</div>
                  ))}
                </td>
              </tr>
            )}
          </table>
        </div>
      </div>
    );
  };

  public render() {
    const emailList = this.props.app.persons
      .filter((person) => !person.removed && !!person.email)
      .map((person) => {
        return {
          value: person.email,
          label: `${person.displayName} (${person.email})`,
        };
      });

    // const sendCopyToEmailList = this.state.sendCopyToEmails
    //   .map(email => {
    //     return ({
    //       value: email,
    //       label: email
    //     });
    //   }
    //   );

    const customStylesForEmail = {
      control: (base, state) => {
        let borderColor = 'rgba(0, 0, 0, 0.23)';
        let boxShadow = 'none !important';
        let outlineColor = 'auto';

        if (state.isFocused) {
          borderColor = '#00BCD4 !important';
          boxShadow = '0 0 1px 1px #00BCD4 !important';
          outlineColor = '#00BCD4 !important';

          if (!!this.getDetailErrorFor('to')) {
            borderColor = '#f44336 !important';
            boxShadow = '0 0 1px 1px #f44336 !important';
            outlineColor = '#f44336 !important';
          }
        } else {
          if (!!this.getDetailErrorFor('to')) {
            borderColor = '#f44336 !important';
            outlineColor = '#f44336 !important';
          }
        }

        return {
          ...base,
          border: state.isFocused ? 'none !important' : 'auto',
          borderColor: borderColor,
          boxShadow: boxShadow,
          outlineColor: outlineColor,
          outlineStyle: state.isFocused ? 'auto !important' : 'auto',
          outlineWidth: state.isFocused ? '5px !important' : 'auto',
          '&:hover': {
            borderColor: !!this.getDetailErrorFor('to') ? '#f44336' : 'black',
          }, // border style on hover
        };
      },
    };

    // const customStylesForCopyToEmail = {
    //   control: (base, state) => {
    //     let borderColor = 'rgba(0, 0, 0, 0.23)';
    //     let boxShadow = 'none !important';
    //     let outlineColor = "auto";

    //     if (state.isFocused) {
    //       borderColor = "#00BCD4 !important";
    //       boxShadow = "0 0 1px 1px #00BCD4 !important";
    //       outlineColor = "#00BCD4 !important";

    //       if (!!this.getDetailErrorFor("sendCopyToEmails")) {
    //         borderColor = "#f44336 !important";
    //         boxShadow = "0 0 1px 1px #f44336 !important";
    //         outlineColor = "#f44336 !important";
    //       }
    //     } else {
    //       if (!!this.getDetailErrorFor("sendCopyToEmails")) {
    //         borderColor = "#f44336 !important";
    //         outlineColor = "#f44336 !important";
    //       }
    //     }

    //     return ({
    //       ...base,
    //       border: state.isFocused ? 'none !important' : "auto",
    //       borderColor: borderColor,
    //       boxShadow: boxShadow,
    //       outlineColor: outlineColor,
    //       outlineStyle: state.isFocused ? "auto !important" : "auto",
    //       outlineWidth: state.isFocused ? "5px !important" : "auto",
    //       '&:hover': {
    //         borderColor: !!this.getDetailErrorFor("to") ? '#f44336' : 'black',
    //       }, // border style on hover
    //     });
    //   }
    // }
    console.log(this.state.emailTo, "this.state.emailTo")
    console.log(emailList.find(
      (item) => item.value === this.state.emailTo
    ), 'emailList');
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div
                className="back-arrow-wrapper"
                onClick={
                  this.state.hasModifiedData
                    ? this.openCancelDialog
                    : this.onDiscard
                }
              >
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans('page/sendemail-title/sendemail')}</h1>
              <div className="button-container-small">
                <Button
                  color="primary"
                  onClick={
                    this.state.hasModifiedData
                      ? this.openCancelDialog
                      : this.onDiscard
                  }
                  style={{ marginRight: '20px' }}
                  disabled={this.state.isSaving}
                >
                  {this.trans('button-cancel')}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.save}
                  disabled={this.state.isSaving}
                >
                  {this.trans('button-send')}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-send-email">
            <div className="component-wrapper no-margin-top no-shadow">
              <div className="component">
                <Card className="card">
                  <div className="row">
                    <div className="grid"></div>
                    <div className="grid" style={{ width: '60%' }}>
                      <div style={{ display: 'flex' }}>
                        <div style={{ margin: 'auto 0', width: '130px' }}>
                          {`${this.trans('from')}:`}
                        </div>
                        <div style={{ color: '#6d6d6d' }}>
                          {this.state.useAgencyNameForEmail
                            ? `${this.getAgency()?.name} ${
                                this.getAgency()?.email || ''
                              }`
                            : `${this.props.app?.session?.user?.firstName} ${this.props.app?.session?.user?.lastName} ${this.props.app?.session?.user?.email}`}
                        </div>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <div style={{ margin: 'auto 0', width: '130px' }}>
                          {`${this.trans('to')}:`}
                        </div>
                        {this.state.showEmailField && (
                          <div
                            style={{
                              position: 'relative',
                              zIndex: 3,
                              minWidth: '50%',
                            }}
                          >
                            <CreatableSelect
                              autoFocus={this.state.autoFocusEmailTo}
                              isMulti
                              isClearable={false}
                              defaultValue={emailList.find(
                                (item) => item.value === this.state.emailTo
                              )}
                              options={emailList}
                              onChange={this.onChange}
                              styles={customStylesForEmail}
                              placeholder={this.trans('mail')}
                              className="form-element scroll-to-to"
                              minMenuHeight={40}
                              maxMenuHeight={
                                window.innerHeight - 280 < 40
                                  ? 40
                                  : window.innerHeight - 280
                              }
                            />
                            {this.state.isNotValidTo && (
                              <div className="component-error-text">
                                {this.trans('be_ajv_not_validated')}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div style={{ display: 'flex' }}>
                        {(this.state.entityName === 'charge' ||
                          this.state.entityName === 'payment' ||
                          this.state.entityName === 'new-contract' ||
                          this.state.entityName === 'statement') && (
                          <div style={{ margin: 'auto 0', width: '130px' }}>
                            {`${this.trans('label-subject')}:`}
                          </div>
                        )}
                        {this.state.entityName === 'charge' && (
                          <div style={{ color: '#6D6D6D' }}>
                            {`${this.trans('charge')} ${
                              this.state.selectedEntityForEmail?.chargeClass
                                .id === 1
                                ? this.trans('to-lowercase')
                                : this.trans('from-lowercase')
                            } ${
                              this.state.selectedEntityForEmail?.name || ''
                            } ${
                              this.state.selectedEntityForEmail?.hasSavingsType
                                ? `(${this.trans(
                                    'charge/payment-summary-title/savings'
                                  )})`
                                : ''
                            }`}
                          </div>
                        )}
                        {this.state.entityName === 'payment' && (
                          <div style={{ color: '#6D6D6D' }}>
                            {`${this.trans('payment')} ${
                              this.state.selectedEntityForEmail?.paymentClass
                                .id === 1
                                ? this.trans('to-lowercase')
                                : this.trans('from-lowercase')
                            } ${this.state.selectedEntityForEmail?.getPayerDisplayName()} ${
                              this.state.selectedEntityForEmail?.hasSavingsType
                                ? `(${this.trans(
                                    'charge/payment-summary-title/savings'
                                  )})`
                                : ''
                            }`}
                          </div>
                        )}
                        {this.state.entityName === 'new-contract' && (
                          <div style={{ color: '#6D6D6D' }}>
                            {`${this.trans(
                              'email/subject-rent-adjust',
                              {},
                              this.state.languageForPdf
                            )} ${
                              this.state.selectedEntityForEmail?.unit
                                ?.shortDisplayName
                                ? this.state.selectedEntityForEmail?.unit
                                    ?.shortDisplayName
                                : this.state.selectedEntityForEmail?.unit
                                    ?.displayName
                            }`}
                          </div>
                        )}
                        {this.state.entityName === 'statement' && (
                          <div style={{ color: '#6D6D6D' }}>
                            {`${this.trans(
                              'send-invoice-subject',
                              {},
                              this.state.languageForPdf
                            )} ${Time.useFormatForUserLanguage(
                              this.state.selectedEntityForEmail?.firstDate,
                              this.state.languageForPdf,
                              'MMMM YYYY'
                            )}`}
                          </div>
                        )}
                      </div>
                      {this.state.showMessageField && (
                        <TextField
                          autoComplete="off"
                          autoFocus={this.state.autoFocusMessage}
                          className="form-element full-size scroll-to-message"
                          type="text"
                          label={
                            this.trans('message') + this.trans('field/optional')
                          }
                          value={this.state.message}
                          onChange={this.sync.bind(
                            this,
                            this.syncronizers.EVENT,
                            'message'
                          )}
                          onKeyPress={() =>
                            this.setState({
                              messageManuallyChanged: true,
                            })
                          }
                          variant="standard"
                          multiline
                          rowsMax="25"
                          error={!!this.getDetailErrorFor('message')}
                          helperText={this.getDetailErrorFor('message')}
                        />
                      )}

                      {this.state.entityName === 'statement' && (
                        <Link
                          onClick={() => {
                            this.saveDetailsBeforeRedirect('emailSend');

                            this.props.dispatch({
                              type: Constants.PAGE_SETTINGS_UPDATE_SWITCH_TAB,
                              payload: {
                                index: 1,
                              },
                            });

                            this.props.dispatch({
                              type: Constants.PAGE_SETTINGS_UPDATE_AGENCY_CATEGORY,
                              payload: {
                                category: 'statementsSettings',
                              },
                            });

                            this.redirect(`/app/settings`);
                          }}
                        >
                          {this.trans('page/sendemail-link/updatedefaulttext')}
                        </Link>
                      )}

                      {/* <p style={{color: "gray"}}>
                        {
                          this.state.entityName === "task" && this.trans("page/sendemail-hint/objectdetails", {object: `${this.state.selectedEntityForEmail?.nameOfEntity} ${this.state.selectedEntityForEmail?.displayName}`})
                        }
                      </p> */}

                      {this.state.entityName === 'charge' &&
                        this.renderChargeDetails(
                          this.state.selectedEntityForEmail
                        )}
                      {this.state.entityName === 'contract' &&
                        this.renderContractDetails(
                          this.state.selectedEntityForEmail
                        )}
                      {this.state.entityName === 'task' &&
                        this.renderTaskDetails()}

                      {this.state.entityName === 'payment' &&
                        this.renderPaymentDetails(
                          this.state.selectedEntityForEmail
                        )}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.useAgencyNameForEmail}
                            style={{ margin: '0' }}
                            onChange={this.switchUseAgencyEmailNameForEmail}
                            color="primary"
                            disabled={!this.getAgency()?.email}
                          />
                        }
                        label={`${this.trans(
                          'use-not-show-username-features'
                        )}: ${this.getAgency()?.name} ${
                          this.getAgency()?.email || ''
                        }`}
                      />
                    </div>
                  </div>
                </Card>
              </div>
            </div>
            <div
              className="checkbox-send-email grid"
              style={{ margin: '5px 0 0 80px' }}
            >
              {!this.getAgency()?.email && (
                <div
                  style={{
                    margin: '0 0 5px 30px',
                    position: 'relative',
                    zIndex: 2,
                  }}
                >
                  <Link
                    onClick={() => {
                      this.saveDetailsBeforeRedirect('emailSend');
                      this.redirect('/app/settings?agencySettings=true');
                    }}
                  >
                    {this.trans(
                      'settings/agencyprofile-info/notshowusername-link'
                    )}
                  </Link>
                </div>
              )}

              {/* {
                        this.state.entityName === "statement" && (
                          <div style={{marginTop: "-15px"}}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.sendCopyTo}
                                  style={{margin: "10px 0"}}
                                  onChange={this.switchSendCopyTo}
                                  color="primary"
                                />
                              }
                              label={this.trans("page/sendemail-label/sendcopyto")}
                            />
                            {
                              this.state.sendCopyTo && (
                                <div style={{paddingLeft: "30px"}}>
                                  {
                                    this.state.showEmailField && (
                                      <div style={{position: "relative", zIndex: 2, marginTop: "-25px"}}>
                                        <CreatableSelect
                                          isMulti
                                          isClearable={false}
                                          defaultValue={sendCopyToEmailList}
                                          options={sendCopyToEmailList}
                                          onChange={this.onChangeSendCopyToEmails}
                                          styles={customStylesForCopyToEmail}
                                          placeholder={this.trans("page/sendemail-label/sendcopytoemails")}
                                          className="form-element scroll-to-sendCopyToEmails"
                                          minMenuHeight={40}
                                          maxMenuHeight={window.innerHeight - 280 < 40 ? 40 : window.innerHeight - 280}
                                        />
                                        {!!this.getDetailErrorFor("sendCopyToEmails") && <div className="component-error-text">{this.getDetailErrorFor("sendCopyToEmails")}</div>}
                                      </div>
                                    )
                                  }

                                  <TextField
                                    autoComplete="off"
                                    className="form-element full-size scroll-to-sendCopyToSubject"
                                    type="text"
                                    label={this.trans("label-subject")}
                                    value={this.state.sendCopyToSubject}
                                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "sendCopyToSubject")}
                                    variant="standard"
                                    error={!!this.getDetailErrorFor("sendCopyToSubject")}
                                    helperText={this.getDetailErrorFor("sendCopyToSubject")}
                                  />
                                </div>
                              )
                            }
                          </div>
                        )
                      } */}
            </div>

            {this.state.attachments.length > 0 && (
              <div className="component-wrapper no-shadow">
                <Attachment
                  {...this.props}
                  typeOfComponent="selectable"
                  title={this.trans('attachments-for-email')}
                  attachments={this.state.attachments}
                  selectedAttachmentsIds={this.state.selectedAttachmentsIds}
                  onAttachmentSelect={this.onAttachmentSelect}
                  attachmentIds={this.state.attachmentIds}
                />
              </div>
            )}
          </div>
        </div>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.openLeavePrompt}
          title={this.trans('dialog/attention-title') + '!'}
          content={this.trans('page/sendemail-dialog/attention-info')}
          positiveButtonLabel={this.trans('dialog-button/cancel')}
          negativeButtonLabel={this.trans(
            'dialog/sendemail-button/donotcancel'
          )}
          onSave={this.onDiscard}
          onDiscard={() => {
            this.setState({ openLeavePrompt: false });
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    events: state.events,
    component: state.emailSend,
    globalTypes: state.globalTypes,
  };
};

export default connect(mapStateToProps)(EmailSend);
